import {
  getHandledError,
  getOperationError,
  getAbnormalError,
  isHandledError,
  isValidationError
} from '../lib/error-utils'

export default {
  methods: {
    getHandledError,
    getOperationError,
    getAbnormalError,
    isHandledError,
    isValidationError,
    handleAjaxError (err) {
      let isHandled = this.isHandledError(err)

      if (!isHandled) {
        if (err.name === 'OperationError') {
          isHandled = true
          alert(this.$t('system.operationFailed'))
        } else if (err.name === 'AbnormalError') {
          isHandled = true
          alert(this.$t('system.wrongApproach'))
          window.location.replace('/')
        } else if (this.isValidationError(err) && this.errors) {
          this.errors = err.response.data
          isHandled = true
        } else {
          console.error(err)
        }
      }
      return isHandled
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/ajax-handler.js